define(function (require) {
    var _ = require("lodash");
    var Enum = require("Enum");

    function FinancialItem(ID_Produit, cTypeFinancialItem, cClasseFinancialItem, nModeCalcul) {
        this.ID_Produit = ID_Produit;
        this.cTypeFinancialItem = cTypeFinancialItem;
        this.cClasseFinancialItem = cClasseFinancialItem;

        this.nModeCalcul = FinancialItem.ModeCalcul.V1;//Default
        if (nModeCalcul != null) {
            this.nModeCalcul = nModeCalcul;
        }
    }

    FinancialItem.prototype.toString = function () {
        //if (this.ID_Produit == null || this.cTypeFinancialItem == null || this.cClasseFinancialItem == null || this.nModeCalcul == null) return;

        return this.ID_Produit.toString() + "_" + this.cTypeFinancialItem.toString() + "_" + this.cClasseFinancialItem.toString() + "_" + this.nModeCalcul.toString();
    }

    FinancialItem.prototype.toID = function () {

        return this.ID_Produit.toString() + "_" + this.cTypeFinancialItem.toString() + "_" + this.cClasseFinancialItem.toString();
    }

    Object.defineProperties(FinancialItem.prototype, {
        "toString": { enumerable: false },
        "toID": { enumerable: false }
    });

    FinancialItem.prototype.equals = function (other) {
        if (other == null) return false;
        if (typeof other != typeof this) return false;

        return this.ID_Produit === other.ID_Produit && this.cTypeFinancialItem === other.cTypeFinancialItem && this.cClasseFinancialItem === other.cClasseFinancialItem;
    }

    //Fill depuis un obj "SearchProduit_Result" retourné par le quantasearch
    FinancialItem.prototype.fill = function (obj) {
        var self = this;
        if (obj == null) return;

        //Iterate sur les properties (non héritées !) de l'objet
        Object.keys(obj).forEach(function (key, index) {
            self[key] = obj[key];
        });
    }

    FinancialItem.prototype.toObject = function () {
        //var toObject = {};
        //var self = this;

        //Object.keys(self).forEach(function (key, index) {
        //    toObject[key] = self[key];
        //});

        //return toObject;
        return {
            ID_Produit: this.ID_Produit,
            cTypeFinancialItem: this.cTypeFinancialItem,
            cClasseFinancialItem: this.cClasseFinancialItem,
            nModeCalcul: this.nModeCalcul
        }
    }

    //Retourne une instance de FinancialItem depuis une chaine du type "84902_1_0"
    FinancialItem.fromString = function (stringID) {
        //https://lodash.com/docs/4.17.4#split
        var splittedString = _.split(stringID, "_");

        if (splittedString.length < 3) return null;

        var ID_Produit = parseInt(splittedString[0]);
        var cTypeFinancialItem = parseInt(splittedString[1]);
        var cClasseFinancialItem = parseInt(splittedString[2]);

        var nModeCalcul = null;
        if (splittedString.length >= 4) {
            nModeCalcul = parseInt(splittedString[3]);
        }

        var oFinancialItem = new FinancialItem(ID_Produit, cTypeFinancialItem, cClasseFinancialItem, nModeCalcul);

        return oFinancialItem;
    }


    //#region Enum ClasseProduit
    FinancialItem.ClasseProduit = new Enum([
        { name: 'QUANTALYS', val: 0 },
        { name: 'EXTERNE', val: 1 },
    ]);
    //#endregion

    //#region Enum TypeFinancialItem
    FinancialItem.TypeFinancialItem = new Enum([
        { name: 'UNDEFINED', val: 0 },
        { name: 'FONDS', val: 1 },
        { name: 'FONDS_EURO', val: 2 },
        { name: 'TITRE', val: 3 },
        { name: 'SCPI', val: 4 },
        //Manque le 5 ! Car doit répliquer TypeFinancialItem (FinancialItem.vb)
        { name: 'PORT_MODELE', val: 6 },
        { name: 'CASH', val: 7 },
        { name: 'ACTION', val: 8 },
        { name: 'OBLIGATION', val: 9 },
        { name: 'CAT', val: 10 },
        { name: 'GROUPE_CAT', val: 11 },
        { name: 'BENCH', val: 12 },
        { name: 'PORTEFEUILLE', val: 13 },
        { name: 'PORTQUANTALYS', val: 14 },
        { name: 'PORTBACKTEST', val: 15 },
        { name: 'PORTSIMULE', val: 16 },
        { name: 'PROPOSITION', val: 17 },
        { name: 'POINTFRONTIER', val: 18 },
        { name: 'ALLOCATIONACTIFSPERSO', val: 19 },
        { name: 'AASURMESURE', val: 20 },
        { name: 'AAPORT', val: 21 },
        { name: 'AAPORTSIMULE', val: 22 },
        { name: 'CASH_SIMULE', val: 23 },
        { name: 'AAQ', val: 24 },
        { name: 'TAUXCHANGE', val: 25 },
        { name: 'STRUCTURE', val: 26 },
        { name: 'OPERATION', val: 27 },
        { name: 'AAPROPOSITION', val: 28 },
        { name: 'FRAIS', val: 29 },
        { name: 'PORTPARHORIZON', val: 30 },
		{ name: 'FCPR', val: 31 },
		{ name: 'PORTGESTIONDELEGUEE', val: 32 },
		{ name: 'FID', val: 33 }
    ]);

    //#region Enum ModeCalcul
    FinancialItem.ModeCalcul = new Enum([
        { name: 'V1', val: 0 },
        { name: 'Normal', val: 1 },
        { name: 'ConstantMix', val: 2 },
        { name: 'BuyAndHold', val: 3 },
    ]);
    //#endregion

    //#endregion
    return FinancialItem;
});
